import React from 'react';
import PropTypes from 'prop-types';
import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';

const Image = ({
  src,
  className,
  objectFit,
  loading,
  style,
  alt,
}) => {
  const data = useStaticQuery(graphql`
    query {
      images: allFile(filter: {extension: {ne: "json"}}) {
        edges {
          node {
            relativePath
            publicURL
            name
            extension
            childImageSharp {
              gatsbyImageData(
                quality: 90
                width: 1600
                formats: [AUTO, WEBP, AVIF]
              )
            }
          }
        }
      }
    }
  `);

  if (!src) {
    return null;
  }

  const image = data.images.edges.find((n) => n.node.relativePath.includes(src));

  // Handle case where image is not found
  if (!image) {
    console.warn(`Image not found: ${src}`);
    return null;
  }

  // Add SVG support
  if (!image.node.childImageSharp && image.node.extension === 'svg') {
    return <img src={image.node.publicURL} alt={alt} className={className} />;
  }

  // Handle case where childImageSharp is not available
  if (!image.node.childImageSharp) {
    console.warn(`childImageSharp not available for: ${src}, using publicURL instead`);
    return <img src={image.node.publicURL} alt={alt} className={className} />;
  }

  const imageObject = image.node.childImageSharp.gatsbyImageData;

  return (
    <GatsbyImage
      image={imageObject}
      alt={alt}
      objectFit={objectFit}
      style={style}
      className={className}
      loading={loading}
    />
  );
};

Image.propTypes = {
  src: PropTypes.string,
  className: PropTypes.string,
  objectFit: PropTypes.string,
  loading: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.any),
  alt: PropTypes.string,

};
Image.defaultProps = {
  src: '',
  className: '',
  objectFit: '',
  loading: 'lazy',
  style: {},
  alt: '',
};

export default Image;
